<template>
  <div class="page">
    <div class="page-head">
      <div>
        <div class="page-title">开通城市</div>
        <p class="sub">小程序左上角城市列表、搜索和推荐房源都按这里维护的开通城市过滤。</p>
      </div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate">新增城市</el-button>
    </div>
    <el-table :data="list" border size="small" v-loading="loading">
      <el-table-column prop="name" label="城市" min-width="140"></el-table-column>
      <el-table-column prop="sortNum" label="排序" width="90"></el-table-column>
      <el-table-column label="小程序展示" width="120">
        <template slot-scope="scope">
          <el-switch
            :value="!!scope.row.enableType"
            @change="val => toggle(scope.row, val)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="180" :formatter="fmtTime"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="mini" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑城市' : '新增城市'" :visible.sync="visible" width="420px">
      <el-form :model="form" :rules="rules" ref="form" label-width="90px" size="small">
        <el-form-item label="城市名称" prop="name">
          <el-input v-model="form.name" maxlength="20" placeholder="如 绥化"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sortNum">
          <el-input-number v-model="form.sortNum" :min="0" :max="999"></el-input-number>
        </el-form-item>
        <el-form-item label="开放">
          <el-switch v-model="form.enableType"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { adminCityList, saveCity, deleteCity } from '../../api/spAdmin'

export default {
  data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      list: [],
      form: { id: '', name: '', sortNum: 1, enableType: true },
      rules: {
        name: [{ required: true, message: '请填写城市名称', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    fmtTime(row, col, val) {
      if (!val) return ''
      return String(val).replace('T', ' ').slice(0, 19)
    },
    load() {
      this.loading = true
      adminCityList().then(res => {
        this.loading = false
        const data = (res && res.data) || []
        this.list = Array.isArray(data) ? data : []
      }, () => {
        this.loading = false
        this.list = []
      })
    },
    openCreate() {
      this.form = { id: '', name: '', sortNum: (this.list.length + 1), enableType: true }
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        sortNum: row.sortNum == null ? 1 : row.sortNum,
        enableType: row.enableType !== false
      }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(ok => {
        if (!ok) return
        this.saving = true
        const payload = {
          name: (this.form.name || '').trim(),
          sortNum: this.form.sortNum,
          enableType: this.form.enableType
        }
        if (this.form.id) payload.id = this.form.id
        saveCity(payload).then(res => {
          this.saving = false
          if (res && res.status === 200) {
            this.$message.success('已保存')
            this.visible = false
            this.load()
          } else {
            this.$message.error((res && res.message) || '保存失败')
          }
        }, err => {
          this.saving = false
          this.$message.error((err && ((err.response && err.response.data && err.response.data.message) || err.message)) || '保存失败')
        })
      })
    },
    toggle(row, val) {
      saveCity({
        id: row.id,
        name: row.name,
        sortNum: row.sortNum,
        enableType: val
      }).then(res => {
        if (res && res.status === 200) {
          this.$message.success(val ? '已开放' : '已关闭')
          this.load()
        } else {
          this.$message.error((res && res.message) || '更新失败')
        }
      }, err => {
        this.$message.error((err && err.message) || '更新失败')
      })
    },
    remove(row) {
      this.$confirm('删除后小程序城市列表不再展示「' + row.name + '」，已发布房源不会自动改城市。确认删除？', '提示', { type: 'warning' }).then(() => {
        return deleteCity(row.id)
      }).then(res => {
        if (res && res.status === 200) {
          this.$message.success('已删除')
          this.load()
        } else if (res) {
          this.$message.error(res.message || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.page { padding: 8px 4px 24px; }
.page-head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; }
.page-title { font-size: 20px; font-weight: 800; color: #1f1633; }
.sub { margin: 8px 0 0; color: #6b6480; font-size: 13px; }
</style>



// WEBPACK FOOTER //
// src/views/housing/cityList.vue